import * as React from "react";
import { forwardRef } from "react";
const SvgTableViewIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 50 50", style: {
  enableBackground: "new 0 0 50 50"
}, xmlSpace: "preserve", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0,0v50h50V0H0z M15,37h-4v-4h4V37z M15,27h-4v-4h4V27z M15,17h-4v-4h4V17z M39,37H19v-4h20V37z M39,27H19v-4h20V27z M39,17 H19v-4h20V17z" }));
const ForwardRef = forwardRef(SvgTableViewIcon);
export { ForwardRef as ReactComponent };
